import { DEFAULT_DECIMAL_PLACES } from "@/appConfig";

export function roundNumber(number: number | null | undefined, decimalPlaces = DEFAULT_DECIMAL_PLACES) {
  if (number === null || number === undefined) {
    return 0;
  }
  return parseFloat(number.toFixed(decimalPlaces));
}

export function roundAsString(number: number, decimalPlaces = DEFAULT_DECIMAL_PLACES) {
  return number.toFixed(decimalPlaces);
}
